export default "__VITE_ASSET__CKegKNeB__"